<button
  [class]="'button button-' + type"
  [class.disabled]="disabled"
  (click)="onClick($event)"
  role="button"
  [attr.aria-disabled]="disabled"
  [attr.aria-label]="ariaLabel">
  {{ text }}
</button>
